var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareoff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(-192.000000, -720.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-24px",
    transform: "translate(192.000000, 720.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11,8.53 L5.7,7.11 C4.8,8.27 4.24,9.61 4.07,11 L6.09,11 C6.23,10.13 6.58,9.28 7.11,8.53 L7.11,8.53 Z M6.09,13 L4.07,13 C4.24,14.39 4.79,15.73 5.69,16.89 L7.1,15.47 C6.58,14.72 6.23,13.88 6.09,13 L6.09,13 Z M7.1,18.32 C8.26,19.22 9.61,19.76 11,19.93 L11,17.9 C10.13,17.75 9.29,17.41 8.54,16.87 L7.1,18.32 L7.1,18.32 Z M13,4.07 L13,1 L8.45,5.55 L13,10 L13,6.09 C15.84,6.57 18,9.03 18,12 C18,14.97 15.84,17.43 13,17.91 L13,19.93 C16.95,19.44 20,16.08 20,12 C20,7.92 16.95,4.56 13,4.07 L13,4.07 Z",
    id: "Shape",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareoff);
export default __webpack_public_path__ + "static/media/squareoff.ff59c38409c67552408164481ee57eb0.svg";
export { ForwardRef as ReactComponent };